import { render, staticRenderFns } from "./InstructionsDialog.vue?vue&type=template&id=47eec1a6&scoped=true"
import script from "./InstructionsDialog.vue?vue&type=script&lang=js"
export * from "./InstructionsDialog.vue?vue&type=script&lang=js"
import style0 from "./InstructionsDialog.vue?vue&type=style&index=0&id=47eec1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eec1a6",
  null
  
)

export default component.exports